<template>
    <div class="float-left">
        <i
            class="fa fa-times-circle fa-lg icon-button"
            title="Cancelar Processo"
            v-if="$temAcessoView('ATADIREX-02') && !processoCancelado"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalCadCancelarProcessosAtaDirex"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                <b-badge variant="warning">Motivo do Cancelamento - Processo Número: {{processoAtaDirexDto.nuProcesso}}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <!-- Dados da Ata -->
            <!-- <b-card> -->
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="cdTipoAta">Tipo Ata</label>
                        <b-form-select
                                id="cdTipoAta"
                                type="text"
                                :options="tipoAta"
                                value-field="key"
                                text-field="label"
                                v-model="ataDirex.cdTipoAta"
                                :disabled="true"
                            >
                            </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="nuAtaDirex">Ata Direx</label>
                        <b-form-input
                            id="nuAtaDirex"
                            type="text"
                            placeholder="99/9999"
                            v-model="ataDirex.nuAtaDirex"
                            v-mask="[
                                        '##/####'
                                    ]"
                            :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="dtReuniao">Data Reunião</label>
                        <b-input-group>
                            <date-picker
                                id="dtReuniao"
                                v-model="ataDirex.dtReuniao"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                :disabled="true"
                            ></date-picker>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <hr/> -->
            <!-- </b-card> -->
            <!-- Fim Dados da Ata -->


            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label for="vcAtaCancelamento">Ata Direx</label>
                        <b-form-input
                            id="vcAtaCancelamento"
                            type="text"
                            placeholder="99/9999"
                            v-model="ataCancelamento"
                            v-mask="[
                                        '##/####'
                                    ]"
                            @input.native="$v.ataCancelamento.$touch()"
                            :state="$v.ataCancelamento.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            A Ata Direx é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcMotivoCancelamento">Motivo do Cancelamento</label>
                        <b-input-group>
                            <b-form-textarea
                                id="vcMotivoCancelamento"
                                type="text"
                                v-model="motivoCancelamento"
                                placeholder="Motivo do Cancelamento"
                                :rows="4"
                                @input.native="$v.motivoCancelamento.$touch()"
                                :state="$v.motivoCancelamento.$error ? false : null"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>Motivo do Cancelamento é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="confirmarCancelamentoProcessoAta()"
                    class="ml-1"
                    :disabled="$v.$invalid"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
    import AtaDirexServicos from '../AtaDirexServicos'
    import { required, minValue } from 'vuelidate/lib/validators'

    export default {
        props: {
            ProcessoAtaDirexPai: Object,
            processoCancelado: Boolean,
            idAta : 0
        },

        validations: {
            motivoCancelamento: {
                required
            },

            ataCancelamento:{
                required
            }
        },

        data(){
            return {
                mostrarModal: false,
                erros: [],
                ataDirex: {},

                ataCancelamento:null,
                motivoCancelamento: null,

                tipoAta: [
                    {
                        key: '1',
                        label: 'Ordinária',
                    },
                    {
                        key: '2',
                        label: 'Extraordinária',
                    }
                ],

                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                processoAtaDirexDto: {
                    idProcessoAta:0,
                    idAtaDirex: this.$route.params.idAtaDirex,
                    nuProcesso: null,
                    nuFolhaAtaDirex: 0,
                    vcObjetoProcesso: null,
                    vcNomeSolicitanteGdoc: null,
                    idTipoContrato:null,
                    codUnidade:0,
                    codSolicitante:0,
                    nuValorGlobalProcesso:0,
                    dtCadastro:null,
                    idSituacaoProcesso:0,
                    usrLoginCadastro:null,
                    vcMotivoCancelamento:null,
                    vcAtaCancelamento:null,
                    processoVinculado:false
                },
            }
        },

        methods: {

            obterAtaDirex() {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ObterInformacoesGeraisAta(this.idAta).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.ataDirex = response.data
                                this.ataDirex.dtReuniao = this.$moment(this.ataDirex.dtReuniao, 'YYYY-MM-DD').format('DD/MM/YYYY')
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            },

            limpar(){
                this.processoAtaDirexDto.idProcessoAta=0
                this.processoAtaDirexDto.idAtaDirex= this.$route.params.idAtaDirex
                this.processoAtaDirexDto.nuProcesso= null
                this.processoAtaDirexDto.nuFolhaAtaDirex= 0
                this.processoAtaDirexDto.vcObjetoProcesso= null
                this.processoAtaDirexDto.vcNomeSolicitanteGdoc= null
                this.processoAtaDirexDto.idTipoContrato=null
                this.processoAtaDirexDto.codUnidade=0
                this.processoAtaDirexDto.codSolicitante=0
                this.processoAtaDirexDto.nuValorGlobalProcesso=0
                this.processoAtaDirexDto.dtCadastro=null
                this.processoAtaDirexDto.idSituacaoProcesso=0
                this.processoAtaDirexDto.usrLoginCadastro=null
                this.processoAtaDirexDto.vcMotivoCancelamento=null
                this.processoAtaDirexDto.vcAtaCancelamento=null
                this.processoAtaDirexDto.processoVinculado=false

                this.motivoCancelamento=null
                this.ataCancelamento=null

            },

            Carregar(){
                this.processoAtaDirexDto.idProcessoAta= this.ProcessoAtaDirexPai.idProcessoAta
                this.processoAtaDirexDto.idAtaDirex= this.ProcessoAtaDirexPai.idAtaDirex
                this.processoAtaDirexDto.nuProcesso= this.ProcessoAtaDirexPai.nuProcesso
                this.processoAtaDirexDto.nuFolhaAtaDirex= this.ProcessoAtaDirexPai.nuFolhaAtaDirex
                this.processoAtaDirexDto.vcObjetoProcesso= this.ProcessoAtaDirexPai.vcObjetoProcesso
                this.processoAtaDirexDto.vcNomeSolicitanteGdoc= this.ProcessoAtaDirexPai.vcNomeSolicitanteGdoc
                this.processoAtaDirexDto.idTipoContrato= this.ProcessoAtaDirexPai.idTipoContrato
                this.processoAtaDirexDto.codUnidade= this.ProcessoAtaDirexPai.codUnidade //this.ProcessoAtaDirexPai.codUnidade
                this.processoAtaDirexDto.codSolicitante= this.ProcessoAtaDirexPai.codSolicitante
                this.processoAtaDirexDto.nuValorGlobalProcesso= this.ProcessoAtaDirexPai.nuValorGlobalProcesso
                this.processoAtaDirexDto.dtCadastro= this.$moment(this.ProcessoAtaDirexPai.dtCadastro).format('DD/MM/YYYY');
                this.processoAtaDirexDto.idSituacaoProcesso=this.ProcessoAtaDirexPai.idSituacaoProcesso
                this.processoAtaDirexDto.usrLoginCadastro=this.ProcessoAtaDirexPai.usrLoginCadastro
                this.processoAtaDirexDto.vcMotivoCancelamento=this.ProcessoAtaDirexPai.vcMotivoCancelamento
                this.processoAtaDirexDto.vcAtaCancelamento=this.ProcessoAtaDirexPai.vcAtaCancelamento
                this.processoAtaDirexDto.processoVinculado=this.ProcessoAtaDirexPai.processoVinculado

                this.motivoCancelamento=this.ProcessoAtaDirexPai.vcMotivoCancelamento
                this.ataCancelamento=this.ProcessoAtaDirexPai.vcAtaCancelamento
            },

            abrirModal() {
                this.limpar();
                this.Carregar();
                if (this.processoAtaDirexDto.processoVinculado){
                    this.$swal({
                        title: 'Atenção',
                        html: `Este processo não poderá ser cancelado, pois já está vinculado a um Contrato ou Convênio
                        <br/><br/>`,
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK',
                    })
                }else{
                    this.obterAtaDirex();
                    this.mostrarModal = true;
                }
            },

            fecharModal() {
                this.mostrarModal = false;
            },

            confirmarCancelamentoProcessoAta() {
                this.$swal({
                    title: 'Cancelar Processo da Ata Direx',
                    html: `Confirma o cancelamento do Processo <b>${this.processoAtaDirexDto.nuProcesso}</b>
                          da Ata Direx <b>${this.ataDirex.nuAtaDirex}</b>?
                    <br/><br/>`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.salvar()
                    }
                })
            },

            salvar(){
                this.processoAtaDirexDto.dtCadastro= this.$moment(this.processoAtaDirexDto.dtCadastro, 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.processoAtaDirexDto.vcMotivoCancelamento = this.motivoCancelamento
                this.processoAtaDirexDto.vcAtaCancelamento = this.ataCancelamento
                // Status de Cancelada
                this.processoAtaDirexDto.idSituacaoProcesso = 3
                //
                this.$store.dispatch('addRequest')
                    AtaDirexServicos.AtualizarProcessoAtaDirex(this.processoAtaDirexDto)
                    .then(response => {
                        if (response) {
                            if (response.success) {
                                this.$emit('listarProcessos')
                                this.fecharModal()
                            }
                            else{
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
            },
        },


    }
</script>
